export function showAdditionalSeoLinksReducer(state: boolean = false): boolean {
  return state;
}
